import { render } from "./index.vue?vue&type=template&id=bd22c7bc"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\avue\\avue3.0\\avue\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.5.12_vue@3.5.27_typescript@5.9.3__webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"packages/element-plus/comment/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bd22c7bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bd22c7bc', __exports__)) {
    console.log('reload')
    api.reload('bd22c7bc', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=bd22c7bc", () => {
    console.log('re-render')
    api.rerender('bd22c7bc', render)
  })

}


export default __exports__